import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import OrderTracking from "./pages/OrderTracking";
import { Toaster } from "sonner";

const App = () => {
  return (
    <Router>
      <Toaster position="top-right" richColors closeButton />

      <Routes>
        <Route path="/:taskId" element={<OrderTracking />} />
        <Route path="/:taskId/admin" element={<OrderTracking />} />
        <Route path="/" element={<div />} />
      </Routes>
    </Router>
  );
};

export default App;
